// Archetype registry. Each entry is a curated, fully-built level-1 character
// the Tier 2 (Archetype) path can offer. Source JSONs live alongside; this
// module aggregates them into a single ordered list.
//
// Phase 2 ships 2 archetypes against the minimal authored SRD content
// (Fighter + Cleric + Soldier + Human + Half-Elf). Phase 3 (SRD content
// authoring) unlocks 6-8 more.
//
// Adding a new archetype:
//   1. Drop a .json in this folder.
//   2. Import + push it below.

import heavyArmorFighter from './heavy-armor-fighter.json';
import healerCleric from './healer-cleric.json';

export const ARCHETYPES = [heavyArmorFighter, healerCleric];

export const findArchetype = (id) => ARCHETYPES.find((a) => a.id === id) || null;
